import React from "react";
import { Link } from "react-router-dom";
import { Check, Star, TrendingUp, Award } from "lucide-react";

export default function WriterLanding() {
  return (
    <div className="max-w-6xl mx-auto px-6 lg:px-10 py-20">
      <div className="text-center">
        <div className="cw-label">For Writers</div>
        <h1 className="font-display text-5xl sm:text-7xl mt-3 leading-none">Write once.<br /><span className="cw-gradient-text">Earn forever.</span></h1>
        <p className="text-white/60 mt-6 max-w-2xl mx-auto">Join 950+ Indian writers monetising their creative brains on CreativeWayz. Upload unlimited scripts, keep up to 90% revenue, and get discovered by 3,400+ brands.</p>
        <div className="flex justify-center gap-3 mt-10">
          <Link to="/signup?role=writer" className="cw-btn-primary" data-testid="writer-apply">Apply as a Writer</Link>
          <a href="/#pricing" className="cw-btn-ghost">See pricing</a>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-6 mt-20">
        {[
          { icon: <TrendingUp />, title: "Passive income, on autopilot", body: "Your scripts stay on the marketplace forever. Every new buyer = another royalty." },
          { icon: <Award />, title: "Get discovered, verified, featured", body: "Yearly writers get the Verified badge and homepage exposure to Indian D2C brands." },
          { icon: <Star />, title: "Built for creative brains", body: "No cold-emailing clients. No revisions. Just upload, price, publish and earn." },
        ].map((b) => (
          <div key={b.title} className="cw-card rounded-2xl p-6">
            <div className="h-10 w-10 rounded-lg bg-[#FF6B00]/15 border border-[#FF6B00]/30 flex items-center justify-center text-[#FF6B00]">{b.icon}</div>
            <h3 className="font-display text-lg mt-4">{b.title}</h3>
            <p className="text-white/60 text-sm mt-2 leading-relaxed">{b.body}</p>
          </div>
        ))}
      </div>

      <div className="cw-card rounded-3xl p-10 mt-16">
        <div className="cw-label">Writer Success</div>
        <h2 className="font-display text-3xl mt-3">"₹78,000 in my first 90 days."</h2>
        <p className="text-white/70 mt-4 max-w-2xl">Aarav Kapoor joined CreativeWayz in April 2025 with 12 scripts. By July, he'd sold 240+ scripts and recovered his yearly plan in the first week.</p>
      </div>

      <ul className="mt-16 grid sm:grid-cols-2 gap-4">
        {["Upload unlimited scripts","Rich text editor with hook templates","Set your own prices","Draft & schedule publishing","Weekly UPI payouts","Real-time sales analytics"].map((f) => (
          <li key={f} className="flex items-center gap-3 text-white/85"><Check className="h-4 w-4 text-[#FF6B00]" /> {f}</li>
        ))}
      </ul>
    </div>
  );
}
